import { render, staticRenderFns } from "./PaymentDetailBody.vue?vue&type=template&id=1f2562e2"
import script from "./PaymentDetailBody.vue?vue&type=script&lang=js"
export * from "./PaymentDetailBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports